import React from 'react';
import {connect} from "react-redux";
import {
    scrollToStepAction,
} from "../../redux/flow-reducer";
import Progress from "./Progress";

const mapStateToProps = state => {

    let obj = {
        flow:state.flow
    }

    return obj;
}

const ProgressContainer = connect(mapStateToProps, {scrollToStep:scrollToStepAction})(Progress);

export default ProgressContainer;